import { Color, Plugin } from 'chart.js';

const darkMode =
  window.matchMedia &&
  window.matchMedia('(prefers-color-scheme: dark)').matches;

const defaultColor = darkMode ? 'white' : 'black';

const significantSegment = 'min-to-avg';

export const minAvgMaxAverageIndicator: Plugin = {

  id: 'minAvgMaxAverageIndicator',

  afterDatasetsDraw: (
    chart,
    _,
    options: {
      enabled?: boolean;
      color?: Color;
      lineWidth?: number;
      overDraw?: number;
    },
  ) => {

    if (!options.enabled) {
      return;
    }

    const color = options?.color ?? defaultColor;
    const lineWidth = options?.lineWidth ?? 1;
    const overDraw = options?.overDraw ?? 0;

    const horizontal = chart.options.indexAxis === 'y';

    const {ctx, scales} = chart;

    chart.data.datasets
      .forEach((dataset: any, datasetIndex: number) => {
        if (dataset.segment !== significantSegment) {
          return;
        }

        const meta = chart.getDatasetMeta(datasetIndex);

        if (!meta || meta.hidden) {
          return;
        }

        meta.data.forEach((bar: any, i: number) => {

          const avg = dataset.originalAvg?.[i];
          if (avg === undefined) {
            return;
          }

          const pixel: number =
            horizontal
              ? scales['x'].getPixelForValue(avg)
              : scales['y'].getPixelForValue(avg);

          ctx.save();
          ctx.strokeStyle = color;
          ctx.lineWidth = lineWidth;
          ctx.beginPath();

          if (horizontal) {

            const indicatorTop = (bar.y - bar.height / 2) - overDraw;
            const indicatorBottom = (bar.y + bar.height / 2) + overDraw;

            ctx.moveTo(pixel, indicatorTop);
            ctx.lineTo(pixel, indicatorBottom);

          } else {

            const indicatorLeft = (bar.x - bar.width / 2) - overDraw;
            const indicatorRight = (bar.x + bar.width / 2) + overDraw;

            ctx.moveTo(indicatorLeft, pixel);
            ctx.lineTo(indicatorRight, pixel);
          }

          ctx.stroke();
          ctx.restore();
        });
      });
  }
};
